export const FrequencyValidationMessages = {
    antennasMustHaveAtLeastOneFrequency:
        'All antennas must have at least one frequency.',
} as const;
